import { Installation } from "../Installation";
import { CurrencyBalance } from "./CurrencyBalance";

export class InstallationWorkload extends Installation {

  /** Total number of operations */
  operationsCount: number = -1;

  /** Processed banknotes quantity */
  banknotesQty: number = -1;

  /** Processed coins quantity */
  coinsQty: number = -1;

  /** List of balances by currency */
  currencyBalance: CurrencyBalance;

  constructor() {
    super();
  }

  public parse(obj: any) {
    super.parse(obj);

    if (obj.OperationsCount != null) this.operationsCount = obj.OperationsCount;

    if (obj.BanknotesQty != null) this.banknotesQty = obj.BanknotesQty;

    if (obj.CoinsQty != null) this.coinsQty = obj.CoinsQty;

    if (obj.CurrencyBalance) {
      this.currencyBalance = new CurrencyBalance();
      this.currencyBalance.parse(obj.CurrencyBalance);
    }
  }

}
